import React from 'react';
import HomeHero from './HomeHero';
import EcosystemSection from './EcosystemSection';
import ConnectivitySection from './ConnectivitySection';
import PlatformSection from './PlatformSection';
import AfricaSection from './AfricaSection';
import WhyGridxSection from './WhyGridxSection';
import FinalCtaSection from './FinalCtaSection';
import '../../styles/Home.css';

// New homepage, built on this branch only. Composes the seven sections of
// the brief in order; each section is its own component so they can be
// reordered, reused, or removed independently.
const Home = () => (
  <div className="gridx-home">
    <HomeHero />
    <EcosystemSection />
    <ConnectivitySection />
    <PlatformSection />
    <AfricaSection />
    <WhyGridxSection />
    <FinalCtaSection />
  </div>
);

export default Home;
